import { useRef, useState } from "react";
import { FormatDateToDDMMYY } from "../../utils/FormatDate"
import HandleUpdateText from "../../utils/HandleUpdateText"
import HandleUpdateSelect from "../../utils/HandleUpdateSelect";
import { Button, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import HandleUpdateMultiselector from "../../utils/liveUpdaterHandlers/HandleUpdateMultiselector";
import HandleUpdateCheckbox from "../../utils/HandleUpdateCheckbox";
import { FaEye, FaFacebook, FaLink, FaLinkedin, FaTiktok, FaTrash, FaYoutube } from "react-icons/fa";
import Modal from "../ui/Modal";
import { BiWorld } from "react-icons/bi";
import { toast } from "react-toastify";
import { BACKEND } from "../../config/configEnvs";
import VerifyValidUrl from "../../utils/VerifyValidUrl"
import axios from "axios";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import Tooltip from "../ui/ToolTip";
import NoDataScreen from "../ui/temp-screens/NoDataScreen";
import AddIcon from "@mui/icons-material/Add";
import { HandleUpdateItem } from "../../utils/basicCrud/HandleUpdateItem";
import { ItemBoxNotEditable } from "./ItemBoxNotEditable";
import { GetStatusColor, PlanBackgroundColor } from "../../utils/GetTextColor";
import { LinkViewer } from "./LinkViewer";

const ItemRowVentasOperativa = ({s, colorAudiovisual}) => {
  const [modalProyectoBorrador, setModalProyectoBorrador] = useState(false)
  const [modalMakingOf, setModalMakingOf] = useState(false)

  return (
    <tr>

      {/* Links grabaciones borrador */}
      <Modal
        activeModal={modalProyectoBorrador}
        onClose={() => setModalProyectoBorrador(false)}
        centered
        title="Links de las grabaciones (borrador) por el especialista"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          <div className="flex flex-col gap-2 items-center justify-center w-full">
            {!Array.isArray(s.grabacionProyectoBorrador) || s.grabacionProyectoBorrador.length === 0 ? (
              <div className="h-[150px] w-full">
                <NoDataScreen border text="No hay links registrados"/>
              </div>
            ) : (
              <div className="flex flex-col gap-2 w-full">
                {s.grabacionProyectoBorrador.map((s) => (
                  <LinkViewer icon={FaLink} value={s.link} />
                ))}
              </div>
            )}
          </div>
        </div>
      </Modal>
      
      {/* Links grabaciones making of*/}
      <Modal
        activeModal={modalMakingOf}
        onClose={() => setModalMakingOf(false)}
        centered
        title="Links de las grabaciones (making of) por el especialista"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          <div className="flex flex-col gap-2 items-center justify-center w-full">
            {!Array.isArray(s.grabacionProyectoMakingOf) || s.grabacionProyectoMakingOf.length === 0 ? (
              <div className="h-[150px] w-full">
                <NoDataScreen border text="No hay links registrados"/>
              </div>
            ) : (
              <div className="flex flex-col gap-2 w-full">
                {s.grabacionProyectoMakingOf.map((s) => (
                  <LinkViewer icon={FaLink} value={s.link} />
                ))}
              </div>
            )}
          </div>
        </div>
      </Modal>

      <td scope="row" className="sticky z-20 left-0 bg-white px-2 py-2 max-w-[250px] border border-gray-300 truncate text-center font-bold">
        <span className="text-xs truncate">
          {s.cotizacion?.cliente?.nombreComercial}
        </span>
      </td>
      <td scope="row" className="px-2 py-2 max-w-[150px] border border-gray-300 truncate text-center">
        <span className={`${GetStatusColor(s.estadoAudiovisual, colorAudiovisual)} text-xs`}>
          {s.estadoAudiovisual ? s.estadoAudiovisual : "No definido"}
        </span>
      </td>
      <td scope="row" className="px-2 py-2 max-w-[200px] border border-gray-300 truncate text-center">
        <span className="text-xs">
          {s.servicio.name}
        </span>
      </td>
      <td scope="row" className="px-2 py-2 max-w-[100px] border border-gray-300 truncate text-center">
        <span className={`${GetStatusColor(s.planServicio.name, PlanBackgroundColor)} text-xs px-2 py-1`}>
          {s.planServicio?.name}
        </span>
      </td>
      <td scope="row" className="px-2 py-2 max-w-[250px] border border-gray-300 truncate text-center">
        <span className="text-xs">
          {s.responsable.name} - {s.responsable.puesto}
        </span>
      </td>
      <td scope="row" className="min-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs whitespace-nowrap">
          {s.cotizacion.cotizador.name}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 truncate text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaIngreso)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaInicio)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-1 py-1 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaInfoCompleta)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaFin)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaTermino)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechEntrega)}
        </span>
      </td>
      <td scope="row" className="max-w-[250px] px-2 py-2 border border-gray-300 text-center">
        <button 
          className="flex items-center w-full justify-center"
          onClick={() => setModalProyectoBorrador(true)}
        >
          <div className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
            <FaEye className="text-xs"/>
          </div>
        </button>
      </td>     
      <td scope="row" className="max-w-[250px] px-2 py-2 border border-gray-300 text-center">
        <button 
          className="flex items-center w-full justify-center"
          onClick={() => setModalMakingOf(true)}
        >
          <div className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
            <FaEye className="text-xs"/>
          </div>
        </button>
      </td>
    </tr>
  )
}

export default ItemRowVentasOperativa